import MuiButton from './MuiButton';
import MuiCardActions from './MuiCardActions';
import MuiCardContent from './MuiCardContent';
import MuiCardHeader from './MuiCardHeader';
import MuiChip from './MuiChip';
import MuiIconButton from './MuiIconButton';
import MuiInputBase from './MuiInputBase';
import MuiLinearProgress from './MuiLinearProgress';
import MuiListItem from './MuiListItem';
import MuiListItemIcon from './MuiListItemIcon';
import MuiOutlinedInput from './MuiOutlinedInput';
import MuiPaper from './MuiPaper';
import MuiTableCell from './MuiTableCell';
import MuiTableRow from './MuiTableRow';
import MuiToggleButton from './MuiToggleButton';
import MuiTypography from './MuiTypography';
import palette from '../palette';
import typography from '../typography';

export default {
    MuiCardActions,
    MuiCardContent,
    MuiCardHeader,
    MuiChip,
    MuiIconButton,
    MuiInputBase,
    MuiLinearProgress,
    MuiListItem,
    MuiListItemIcon,
    MuiOutlinedInput,
    MuiPaper,
    MuiTableCell,
    MuiTableRow,
    MuiToggleButton,
    MuiTypography,

    MuiButton: {
        ...MuiButton,
        containedPrimary: {
            '&:hover': {
                backgroundColor: palette.primary.main
            }
        }
    },
    MuiBottomNavigation: {
        root: {
            backgroundColor: palette.primary.main
        }
    },
    MuiBottomNavigationAction: {
        root: {
            color: palette.white,
            '&.Mui-selected': {
                color: palette.white,
                fontWeight: typography.fontWeightBold,

            }
        }
    },
    MuiDivider: {
        root: {
            backgroundColor: palette.background.default
        }
    },
    MuiDrawer: {
        root: {
            '& $paper': {
                border: 0
            }
        }
    },
    MUIDataTable: {
        responsiveBase: {
            overflow: 'auto'
        }
    },
    MUIDataTableToolbarSelect: {
        root: {
            backgroundColor: palette.background.paper
        }
    },
    MUIDataTableSelectCell: {
        headerCell: {
            backgroundColor: palette.background.gray,
            color: palette.white
        }
    },
    MUIDataTableHeadCell: {
        fixedHeader: {
            backgroundColor: palette.background.gray,
            color: palette.white
        },
        sortActive: {
            color: palette.white
        }
    },
    MuiTableHead: {
        root: {
            backgroundColor: palette.background.gray,
            '& *': {
                color: palette.white
            },
            '& span.MuiButtonBase-root': {
                color: palette.white
            }
        }
    },
    MuiAlert: {
        message: {
            whiteSpace: 'break-spaces'
        },
        standardSuccess: {
            backgroundColor: palette.success.main,
            color: palette.white,
            '& *': {
                color: palette.white
            }
        },
        standardError: {
            backgroundColor: palette.error.main,
            color: palette.white,
            '& *': {
                color: palette.white
            }
        }
    },
    MuiTab: {
        wrapper: {
            fontWeight: 600
        }
    },
    MuiBreadcrumbs: {
        li: {
            '& > a, a:visited': {
                color: 'inherit'
            }
        }
    },
    MUIDataTableToolbar: {
        filterPaper: {
            width: '90%',
            maxWidth: '800px'
        }
    },
    MUIDataTableFilter: {
        resetLink: {
            display: 'none'
        }
    },
    MUIDataTableBodyRow: {
        root: {
            '& > td': {
                maxWidth: 200
            }
        }
    },
    MUIDataTableBodyCell: {
        root: {
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis'
        }
    },
    MUIDataTableFilterList: {
        chip: {
            marginBottom: '10px',
            border: '1px solid #e2e6e9'
        }
    },
    MuiCssBaseline: {
        '@global': {
            '*::-webkit-scrollbar': {
                width: '7px',
                height: '7px'
            },
            '*::-webkit-scrollbar-thumb': {
                backgroundColor: '#aaa',
                borderRadius: 5
            }
        }
    }
};